import { useMemo } from "react";
import { CourseMaterial, useProgramDetails } from "./coursesLoader";
import useTermOptDeadline from "./useTermOptDeadline";

// This hook determines the opt-out deadline for a specific course material.
// For IA-only programs, the deadline comes from the material's `optOutDeadline`; otherwise it uses the current term.
// If you need the term deadline directly, use the `useTermOptDeadline` hook instead.
export default function useMaterialOptDeadline({
  optOutDeadline,
}: CourseMaterial) {
  const { optDeadline: termOptDeadline, optWindowOpen: termOptWindowOpen } =
    useTermOptDeadline();
  const { scope } = useProgramDetails();
  const deadlineDate = optOutDeadline ? new Date(optOutDeadline) : undefined;
  const materialOptWindowOpen = deadlineDate
    ? new Date() < deadlineDate
    : false;

  return useMemo(() => {
    return {
      optWindowOpen:
        scope === "ia_only" ? materialOptWindowOpen : termOptWindowOpen,
      optDeadline: scope === "ia_only" ? optOutDeadline : termOptDeadline,
    };
  }, [
    scope,
    materialOptWindowOpen,
    termOptWindowOpen,
    optOutDeadline,
    termOptDeadline,
  ]);
}
